import script from "./emoji-dialog-mobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-dialog-mobile.vue?vue&type=script&lang=ts&setup=true"

import "./emoji-dialog-mobile.vue?vue&type=style&index=0&id=7eb60f4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb60f4c"]])

export default __exports__